"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variant;
(function(Variant) {
  Variant["PRIMARY"] = "primary";
  Variant["SECONDARY"] = "secondary";
  Variant["SUCCESS"] = "success";
  Variant["DANGER"] = "danger";
  Variant["WARNING"] = "warning";
  Variant["INFO"] = "info";
  Variant["DARK"] = "dark";
  Variant["LIGHT"] = "light";
})((Variant = exports.Variant || (exports.Variant = {})));
var CellType;
(function(CellType) {
  CellType["TEXT"] = "text";
  CellType["BADGE"] = "badge";
  CellType["BUTTON"] = "button";
  CellType["LIST"] = "list";
  CellType["DROPDOWN"] = "dropdown";
  CellType["TEXT_LINK"] = "text-link";
  CellType["INDICATOR"] = "indicator";
  CellType["TEXT_WITH_CAPTION"] = "text-with-caption";
  CellType["ACTION"] = "action";
  CellType["OBJECT"] = "obj";
})((CellType = exports.CellType || (exports.CellType = {})));
//# sourceMappingURL=index.js.map
